import type { ExtractPropTypes } from 'vue'

export const T_EXPANDABLE_TEXT_PROPS = {
  /**
   * The full text content to display
   */
  text: {
    type: String,
    required: true,
  },
  /**
   * Maximum character length before truncation
   */
  maxLength: {
    type: Number,
    required: true,
  },
  /**
   * Label for the expand button (default: "Show more")
   * If empty string, only shows the icon
   */
  expandLabel: {
    type: String,
    default: 'Show more',
  },
  /**
   * Label for the collapse button (default: "Show less")
   * If empty string, only shows the icon
   */
  collapseLabel: {
    type: String,
    default: 'Show less',
  },
  /**
   * Whether to show chevron icon alongside the label (default: true)
   */
  showIcon: {
    type: Boolean,
    default: true,
  },
} as const

export type TExpandableTextProps = ExtractPropTypes<
  typeof T_EXPANDABLE_TEXT_PROPS
>
